export interface ToastAction {
    id: string;
    label: string;
}

export enum PortalToastType {
    Info = 'info',
    Error = 'error',
    Warning = 'warning',
    Success = 'success',
    None = 'none',
}

export interface ToastIcon {
    /**
    * Name of the icon
   */
    name: string;
    /**
    * Aria Label of the icon
   */
    ariaLabel?: string;
}

export const ICON_MAP: Map<PortalToastType, ToastIcon> = new Map([
    [
        PortalToastType.Info,
        {
            name: 'message',
            ariaLabel: 'Info',
        },
    ],
    [
        PortalToastType.Success,
        {
            name: 'check_circle',
            ariaLabel: 'Success',
        },
    ],
    [
        PortalToastType.Warning,
        {
            name: 'warning',
            ariaLabel: 'Warning',
        },
    ],
    [
        PortalToastType.Error,
        {
            name: 'error',
            ariaLabel: 'Error',
        },
    ],
]);
